<template>
	<div>
		<Layout>
			<div class="container mt-3">
				<div class="row row-xs d-flex">
					<div class="col-12 mt-4 mb-4">
						<h1>Mi cuenta</h1>
					</div>
				</div>
				<div class="row row-xs d-flex no-wrap" v-if="!loading">
					<AccountSidebar />
					<div class="page">
						<div style="width:100%; margin:auto" class="d-flex justify-content-end">
							<div
								class="btn btn-light-outline opacity-3"
								@click="requestRefund(ticket.id)"
								v-if="ticket.canRequestRefund"
							>
								Cancelar ticket
							</div>

							<div class="btn btn-light-outline opacity-5" @click="print" v-if="ticket.status == 'VALID'">
								<svg
									style="width:20px;height:20px; margin-right:5px"
									xmlns="http://www.w3.org/2000/svg"
									class="icon icon-tabler icon-tabler-printer"
									width="24"
									height="24"
									viewBox="0 0 24 24"
									stroke-width="2"
									stroke="currentColor"
									fill="none"
									stroke-linecap="round"
									stroke-linejoin="round"
								>
									<path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
									<path
										d="M17 17h2a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-14a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2"
									></path>
									<path d="M17 9v-4a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2v4"></path>
									<rect x="7" y="13" width="10" height="8" rx="2"></rect>
								</svg>
								Imprimir
							</div>
						</div>

						<div class="ticket" id="ticket">
							<div class="box">
								<div v-if="ticket.status == 'REFUND_REQUESTED'" class="alert alert-warning">
									CANCELACIÓN SOLICITADA
								</div>
								<div
									v-if="ticket.status == 'REFUNDED' || ticket.status == 'CANCELLED'"
									class="alert alert-danger"
								>
									TICKET CANCELADO
								</div>

								<div class="d-flex">
									<div
										class="image mr-3"
										:style="
											`background-image: url(${ticket.ticketType.ticketGroup.event.image.url})`
										"
										v-if="ticket.ticketType.ticketGroup.event.image"
									></div>

									<div>
										<h1>{{ ticket.ticketType.ticketGroup.event.name }}</h1>
										<h2>{{ ticket.ticketType.ticketGroup.event.location.name }}</h2>
										<p class="mt-1">
											{{ ticket.ticketType.ticketGroup.event.location.address }} -
											{{ ticket.ticketType.ticketGroup.event.location.locality.name }}
											{{ ticket.ticketType.ticketGroup.event.location.locality.region.name }}
										</p>
										<div class="date mt-2">
											{{ ticket.ticketType.ticketGroup.event.startAt | moment("DD MMM YYYY")
											}}<br />
											{{ ticket.ticketType.ticketGroup.event.startAt | moment("HH:mm") }}
										</div>
										<span> </span>
									</div>
								</div>

								<div class="ticket-blocks">
									<div class="ticket-block ticket-block-client flex-grow-1">
										<div>
											<div class="label">Cliente</div>
											<div class="value" v-if="ticket.holder">
												{{ ticket.holder.name }} {{ ticket.holder.lastname }}<br />
												<span>{{ ticket.holder.documentText }}</span>
											</div>
											<div
												class="value"
												v-if="ticket.order && ticket.order.user && !ticket.holder"
											>
												{{ ticket.order.user.name }} {{ ticket.order.user.lastname }}<br />
												<span>{{ ticket.order.user.documentText }}</span>
											</div>
										</div>
									</div>
									<div class="ticket-block flex-grow-1">
										<div>
											<div class="label">Ticket</div>
											<div class="value">
												{{ ticket.ticketType.name }}<br />
												<span>{{ ticket.ticketType.ticketGroup.name }}</span>
											</div>
										</div>
									</div>
									<div class="ticket-block ">
										<div class="text-right w-100">
											<div class="label">PRECIO</div>
											<div class="price" v-if="ticket.type == 'COURTESY'">
												CORTESÍA
											</div>
											<div class="price" v-if="ticket.type != 'COURTESY'">
												{{ ticket.currencySymbol }} {{ ticket.price | toCurrency }}
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="box box-bottom" v-if="ticket.status == 'REFUNDED'">
								<div class="divider"></div>
								<div class="py-3 text-center">
									El ticket ha sido cancelado y reembolsado.
								</div>
							</div>

							<div class="box box-bottom" v-if="ticket.status == 'REFUND_REQUESTED'">
								<div class="divider"></div>
								<div class="py-3 ">
									Tu solicitud de cancelación y reembolso ha sido enviada.<br />
									En breve el organizador del evento evaluará tu solicitud y te notificará por correo
									electrónico.
								</div>
							</div>

							<div
								class="box box-bottom"
								:class="{ 'opacity-7': ticket.status == 'REFUND_REQUESTED' }"
								v-if="ticket.status == ('VALID' || 'REFUND_REQUESTED')"
							>
								<div class="divider"></div>

								<div class="text-center mt-3" :class="{ blur: ticket.status == 'REFUND_REQUESTED' }">
									<img :src="`${API_URL}/qr/${ticket.code}.png`" alt="" />
								</div>
								<div class="mt-3 text-center" :class="{ blur: ticket.status == 'REFUND_REQUESTED' }">
									<div class="label">VALIDO HASTA:</div>
									<div class="value">
										{{ ticket.ticketType.ticketGroup.validAt | moment("ddd DD [de] MMMM HH:mm") }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<TicketRequestRefund ref="ticketRequestRefund" @updated="loadTicket()" />
			<TicketPrint ref="ticketPrint" />
		</Layout>
	</div>
</template>

<script>
import gql from "graphql-tag"
import Layout from "@/components/Layout"
import AccountSidebar from "@/views/account/AccountSidebar"
import TicketRequestRefund from "./TicketRequestRefund"
import TicketPrint from "./TicketPrint"

export default {
	name: "TicketDetail",
	components: {
		Layout,
		AccountSidebar,
		TicketRequestRefund,
		TicketPrint
	},
	data() {
		return {
			loading: true,
			ticket: null
		}
	},

	async beforeMount() {
		this.loading = true
		if (!this.$route.params.id) this.$router.go(-1)
		await this.loadTicket()
		this.loading = false
	},

	methods: {
		requestRefund(ticket) {
			this.$refs.ticketRequestRefund.open(ticket)
		},
		async print() {
			this.$refs.ticketPrint.print()
		},
		loadTicket() {
			return this.$apollo
				.query({
					query: gql`
						query($id: ID!) {
							ticket(id: $id) {
								id
								code
								currencySymbol
								price
								type
								holder {
									id
									name
									lastname
									email
								}
								ticketType {
									id
									name
									ticketGroup {
										id
										name
										validAt
										event {
											id
											name
											startAt
											image {
												id
												url
												urlThumb
											}
											location {
												id
												name
												address
												locality {
													id
													name
													region {
														id
														name
													}
												}
											}
										}
									}
								}

								order {
									id
									paidAt
									user {
										id
										name
										lastname
										email
										documentText
									}
									status
								}
								canRequestRefund
								status
								statusText
								statusClass
							}
						}
					`,
					variables: {
						id: this.$route.params.id
					},
					fetchPolicy: "network-only"
				})
				.then(({ data }) => {
					this.ticket = data.ticket
					this.loading = false
				})
		}
	}
}
</script>

<style scoped lang="scss">
.ticket {
	margin: 0px auto 50px auto;
	width: 100%;
	display: flex;
	flex-direction: column;

	.box {
		flex-grow: 1;
		border-radius: 8px;
		background-color: #fff;
		box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.05);
		padding: 16px;
		position: relative;

		h1 {
			font-size: 1.4rem;
		}
		h2 {
			font-size: 1rem;
			margin: 0px;
		}
		p {
			margin: 0px;
		}
		.image {
			background-size: cover;
			background-position: center center;
			width: 120px;
			height: 120px;
			border-radius: 4px;
		}
		.date {
			font-size: 1.2rem;
			font-weight: 500;
			line-height: 1.2rem;
		}
		.ticket-blocks {
			margin-top: 12px;
			display: flex;
			justify-content: space-between;
			gap: 6px;
			flex-wrap: wrap;

			.ticket-block {
				background-color: #f3f3f3;
				border-radius: 4px;
				padding: 12px 12px 10px 12px;
				display: flex;
				min-width: 100px;
				align-items: center;
				justify-content: space-between;

				.label {
					text-transform: uppercase;
					font-size: 0.75rem;
					line-height: 0.8rem;
				}
				.value {
					margin-top: 3px;
					font-size: 1rem;
					line-height: 1.1rem;
					font-weight: 500;

					span {
						font-size: 0.86rem;
					}
				}

				.price {
					font-size: 1rem;
					font-weight: 500;
				}

				&.ticket-block-client {
					width: 100%;
					flex-basis: auto;
				}
			}
		}

		.divider {
			position: absolute;
			margin: 0px;
			z-index: 1;
			top: -4px;
			left: 10px;
			border-top: dotted 6px #e9edef;
			border-left: none;
			height: 0px;
			width: calc(100% - 20px);
		}
		.alert {
			margin-top: -16px;
			margin-left: -16px;
			margin-right: -16px;
			border-radius: 8px 8px 0px 0px;
			font-weight: 500;

			&.alert-danger {
				background-color: #d73a49;
				color: #fff;
			}
		}
	}
}

@media (min-width: 991px) {
	.ticket {
		flex-direction: row;

		.divider {
			top: 10px !important;
			left: -4px !important;
			border-left: dotted 6px #e9edef !important;
			width: 0px !important;
			height: calc(100% - 20px) !important;
		}

		.ticket-block-client {
			width: auto !important;
		}
	}
}

.page {
	width: 100%;
}

.blur {
	filter: blur(2px);
}

.container /deep/ .event-card {
	.image {
		width: 120px;
		height: 120px;
	}
	.data {
		padding: 8px 16px;
		h2.title {
			font-size: 1.5rem;
		}
	}
}

.no-wrap {
	flex-wrap: nowrap;
}
</style>
